import { jwtDecode } from 'jwt-decode';
import React, { createContext, useState, useEffect, useContext } from 'react';
import { useCookies } from 'react-cookie';
import { useSearchParams } from 'react-router-dom';
import slugify from 'slugify';

export const Api = createContext();
export const useApi = () => useContext(Api);
export const ApiProvider = ({ children }) => {
    const [products, setProducts] = useState([]);
    const [pageCount, setPageCount] = useState();
    const [productsCount, setProductsCount] = useState();
    const [inStockProducts, setInStockProducts] = useState();
    const [result, setResult] = useState();
    const [loading, setLoading] = useState(true);

    const [orders, setOrders] = useState([]);
    const [approvedOrdersCount, setApprovedOrdersCount] = useState();
    const [ordersRevenue, setOrdersRevenue] = useState();
    const [orderPageCount, setOrderPageCount] = useState();
    const [ordersCount, setOrdersCount] = useState();
    const [ordersResult, setOrdersResult] = useState();
    const [ordersLoading, setOrdersLoading] = useState(true);
    
    const [logs, setLogs] = useState([]);
    const [logsPageCount, setLogsPageCount] = useState();
    const [logsCount, setLogsCount] = useState();
    const [logsResult, setLogsResult] = useState();
    const [logsLoading, setLogsLoading] = useState(true);

    const [categories, setCategories] = useState([]);
    const [loadingCategories, setLoadingCategories] = useState(true);

    const [banners, setBanners] = useState([]);
    const [loadingBanners, setLoadingBanners] = useState(true);

    const [siteContent, setSiteContent] = useState([]);
    const [loadingSiteContent, setLoadingSiteContent] = useState(true);

    const [longDescriptions, setLongDescriptions] = useState([]);
    const [longDescTotal, setLongDescTotal] = useState(0);
    const [longDescPage, setLongDescPage] = useState(1);
    const [longDescPageCount, setLongDescPageCount] = useState(1);
    const [loadingLongDesc, setLoadingLongDesc] = useState(true);
    const [longDescSearchTerm, setLongDescSearchTerm] = useState('');

    const [campaigns, setCampaigns] = useState([]);
    const [loadingCampaigns, setLoadingCampaigns] = useState(true);

    const [productImages, setProductImages] = useState([]);
    const [loadingImages, setLoadingImages] = useState(true);
    const [imagesTotal, setImagesTotal] = useState(0);
    const [imagesPage, setImagesPage] = useState(1);
    const [imagesPageCount, setImagesPageCount] = useState(1);

    const [searchParams, setSearchParams] = useSearchParams({});
    const page = parseInt(searchParams.get('page') || 1);
    const q = searchParams.get('q') || '';

    const [ordSearchParams, setOrdSearchParams] = useSearchParams({});
    const pageOrd = parseInt(ordSearchParams.get('pageOrd') || 1);
    const qOrd = ordSearchParams.get('qOrd') || '';
    const orderStatus = ordSearchParams.get('orderstatus') || '';

    const [logsSearchParams, setLogsSearchParams] = useSearchParams({});
    const pageLog = parseInt(logsSearchParams.get('pageLog') || 1);
    const qLog = logsSearchParams.get('qLog') || '';


    const handleFilterChange = (filterType, value = false) => {
        let params = new URLSearchParams(searchParams.toString());

        if (filterType === 'q') {
            params = new URLSearchParams();
            params.set('q', slugify(value));
        }
        else if (filterType === 'status') {
            params.set('status', value);
        }
        else if (filterType === 'page') {
            params.set('page', value);
        }

        setSearchParams(params);
    };

    const handleordersFill = (filterType, value = false) => {
        let params = new URLSearchParams(ordSearchParams.toString());

        if (filterType === 'q') {
            params = new URLSearchParams();
            params.set('qOrd', slugify(value));
        }
        else if (filterType === 'page') {
            params.set('pageOrd', value);
        }

        setOrdSearchParams(params);
    };

    const handleLogsFill = (filterType, value = false) => {
        let params = new URLSearchParams(ordSearchParams.toString());

        if (filterType === 'q') {
            params = new URLSearchParams();
            params.set('qLog', slugify(value));
        }
        else if (filterType === 'page') {
            params.set('pageLog', value);
        }

        setLogsSearchParams(params);
    };

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                setLoading(true);
                const productsResponse = await fetch(`https://elnaf.fi/new/api/allProdAdmin.php?page=${page}&q=${q}&lang=${'en'}`);
                const productsData = await productsResponse.json();

                setProducts(productsData.products);
                setLoading(false);
                setInStockProducts(productsData.inStock);
                setPageCount(productsData.totalPages);
                setProductsCount(productsData.totalProducts)
                setResult(productsData.result)
            } catch (error) {
                console.error('Məlumatları yükləyərkən xəta baş verdi:', error);
            }
        };

        fetchProducts();
    }, [searchParams]);

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                setOrdersLoading(true);
                const ordersResponse = await fetch(`https://elnaf.fi/new/api/orders.php?page=${pageOrd}&q=${qOrd}&status=${orderStatus}`);
                const ordersData = await ordersResponse.json();
                setOrders(ordersData.orders);
                setApprovedOrdersCount(ordersData.approved);
                setOrdersRevenue(ordersData.revenue);
                setOrdersLoading(false);
                setOrderPageCount(ordersData.totalPages);
                setOrdersCount(ordersData.totalOrders)
                setOrdersResult(ordersData.result)
            } catch (error) {
                console.error('Məlumatları yükləyərkən xəta baş verdi:', error);
            }
        };

        fetchOrders();
        const interval = setInterval(() => {
            fetchOrders();
        }, 10000);

        return () => clearInterval(interval);
    }, [ordSearchParams]);

    useEffect(() => {
        const fetchLogs = async () => {
            try {
                setLogsLoading(true);
                const logsResponse = await fetch(`https://elnaf.fi/new/api/logs.php?page=${pageLog}&q=${qLog}`);
                const logsData = await logsResponse.json();
                setLogs(logsData.logs);
                setLogsLoading(false);
                setLogsPageCount(logsData.totalPages);
                setLogsCount(logsData.totalLogs)
                setOrdersResult(logsData.result)
            } catch (error) {
                console.error('Məlumatları yükləyərkən xəta baş verdi:', error);
            }
        };

        fetchLogs();
        const interval = setInterval(() => {
            fetchLogs();
        }, 10000);

        return () => clearInterval(interval);
    }, [logsSearchParams]);

    const fetchCategories = async () => {
        try {
            setLoadingCategories(true);
            const categoriesResponse = await fetch(`https://elnaf.fi/new/api/allCategory.php`);
            const categoriesData = await categoriesResponse.json();
            setCategories(categoriesData);
            setLoadingCategories(false);
        } catch (error) {
            console.error('Kateqoriyaları yükləyərkən xəta baş verdi:', error);
            setLoadingCategories(false);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchBanners = async () => {
        try {
            setLoadingBanners(true);
            const bannersResponse = await fetch(`https://elnaf.fi/new/api/get_banners.php`);
            const bannersData = await bannersResponse.json();
            console.log('Banners API response:', bannersData);
            setBanners(bannersData.banners || bannersData);
            setLoadingBanners(false);
        } catch (error) {
            console.error('Bannerləri yükləyərkən xəta baş verdi:', error);
            setLoadingBanners(false);
        }
    };

    useEffect(() => {
        fetchBanners();
    }, []);

    const fetchSiteContent = async () => {
        try {
            setLoadingSiteContent(true);
            const contentResponse = await fetch(`https://elnaf.fi/new/api/get_site_content.php`);
            const contentData = await contentResponse.json();
            console.log('Site content API response:', contentData);
            setSiteContent(contentData);
            setLoadingSiteContent(false);
        } catch (error) {
            console.error('Site content yükləyərkən xəta baş verdi:', error);
            setLoadingSiteContent(false);
        }
    };

    useEffect(() => {
        fetchSiteContent();
    }, []);

    const fetchLongDescriptions = async () => {
        try {
            setLoadingLongDesc(true);
            
            // If there's a search query, use the search endpoint
            if (longDescSearchTerm) {
                const searchResponse = await fetch(`https://elnaf.fi/new/api/search_by_long_desc.php?q=${longDescSearchTerm}`);
                const searchData = await searchResponse.json();
                console.log('Search results:', searchData);
                
                setLongDescriptions(searchData || []);
                setLongDescTotal(searchData.length);
                setLongDescPage(1);
                setLongDescPageCount(1); // Search results don't have pagination
            } else {
                // Normal fetch without search
                const response = await fetch(`https://elnaf.fi/new/api/get_long_descriptions.php?page=${longDescPage}`);
                const data = await response.json();
                console.log('Long descriptions API response:', data);
                
                setLongDescriptions(data.data || []);
                setLongDescTotal(data.total || 0);
                setLongDescPage(data.page || 1);
                const totalPages = Math.ceil((data.total || 0) / (data.limit || 25));
                setLongDescPageCount(totalPages);
            }
            
            setLoadingLongDesc(false);
        } catch (error) {
            console.error('Long descriptions yükləyərkən xəta baş verdi:', error);
            setLoadingLongDesc(false);
        }
    };

    const deleteLongDescription = async (sku) => {
        try {
            const formData = new FormData();
            formData.append('SKU', sku);
            
            const response = await fetch('https://elnaf.fi/new/api/delete_long_desc.php', {
                method: 'POST',
                body: formData
            });
            
            const data = await response.json();
            return data.status === 'success' || data.message?.includes('uğurla');
        } catch (error) {
            console.error('Error deleting long description:', error);
            return false;
        }
    };

    const setLongDescSearchParam = (key, value) => {
        if (key === 'q') {
            setLongDescSearchTerm(value);
        } else if (key === 'page') {
            setLongDescPage(value);
        }
    };

    useEffect(() => {
        fetchLongDescriptions();
    }, [longDescSearchTerm, longDescPage]);

    const fetchCampaigns = async () => {
        try {
            setLoadingCampaigns(true);
            const response = await fetch('https://elnaf.fi/new/api/get_campaigns.php');
            const data = await response.json();
            console.log('Campaigns API response:', data);
            setCampaigns(data || []);
            setLoadingCampaigns(false);
        } catch (error) {
            console.error('Campaigns yükləyərkən xəta baş verdi:', error);
            setLoadingCampaigns(false);
        }
    };

    useEffect(() => {
        fetchCampaigns();
    }, []);

    const fetchProductImages = async (page = 1, limit = 20, search = '') => {
        try {
            setLoadingImages(true);
            let url = `https://elnaf.fi/new/api/list_product_images.php?page=${page}&limit=${limit}`;
            if (search) {
                url += `&q=${encodeURIComponent(search)}`;
            }
            
            const response = await fetch(url);
            const data = await response.json();
            console.log('Product images API response:', data);
            
            // Transform the new structure to a flat array for easier handling
            const flatImages = [];
            if (data.data) {
                data.data.forEach(product => {
                    if (product.image_urls) {
                        product.image_urls.forEach((img, index) => {
                            flatImages.push({
                                id: `${product.sku}-${index}`, // Create a unique ID
                                sku: product.sku,
                                image_url: img.url,
                                sort_order: img.sort_order
                            });
                        });
                    }
                });
            }
            
            setProductImages(flatImages);
            setImagesTotal(data.total || 0);
            setImagesPage(data.page || 1);
            const totalPages = Math.ceil((data.total || 0) / (data.limit || limit));
            setImagesPageCount(totalPages);
            setLoadingImages(false);
        } catch (error) {
            console.error('Product images yükləyərkən xəta baş verdi:', error);
            setLoadingImages(false);
        }
    };

    const updateImageOrders = async (images) => {
        try {
            // For now, we'll update each image individually
            // In a real app, you might want a batch update endpoint
            const updatePromises = images.map(async (image) => {
                const response = await fetch('https://elnaf.fi/new/api/update_product_image.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        id: image.id,
                        sort_order: image.sort_order
                    })
                });
                return response.json();
            });
            
            await Promise.all(updatePromises);
            console.log('Sort orders updated successfully');
        } catch (error) {
            console.error('Error updating sort orders:', error);
        }
    };
   
    return (
        <Api.Provider value={{
            logs, logsCount, logsPageCount,handleLogsFill,
            products, result, pageCount, page, productsCount, inStockProducts, searchParams, handleFilterChange, loading,
            orders, ordersResult, orderPageCount, pageOrd, ordersCount, ordSearchParams, handleordersFill, ordersLoading, approvedOrdersCount, ordersRevenue,
            categories, loadingCategories, fetchCategories,
            banners, loadingBanners, fetchBanners,
            siteContent, loadingSiteContent, fetchSiteContent,
            longDescriptions, longDescTotal, longDescPage, longDescPageCount, loadingLongDesc,
            fetchLongDescriptions, deleteLongDescription, setLongDescSearchParams: setLongDescSearchParam,
            campaigns, loadingCampaigns, fetchCampaigns,
            productImages, loadingImages, imagesTotal, imagesPage, imagesPageCount, 
            fetchProductImages, updateImageOrders
        }}>
            {children}
        </Api.Provider>
    );

};